import { z } from 'zod';

// utils/zodResolverCustom.ts
export function zodResolverCustom<T extends z.ZodTypeAny>(schema: T) {
  // Mantine accepts validate as a function that receives values
  // and returns an object where keys are field paths and values are error messages.
  return (values: unknown): Record<string, string> => {
    const result = schema.safeParse(values);
    if (result.success) return {};

    const errors: Record<string, string> = {};
    const issues = result.error?.issues || [];
    issues.forEach((issue: z.ZodIssue) => {
      // join Zod path into dot-notation string that Mantine expects
      const path = issue.path.length ? issue.path.join('.') : '_form';
      // If multiple issues for the same path, prefer first (or append)
      if (!errors[path]) errors[path] = issue.message;
      else errors[path] = `${errors[path]}, ${issue.message}`;
    });

    return errors;
  };
}
